import { StepLocationRelativeToParent } from '@activepieces/shared';
import {
  BaseEdge,
  EdgeProps,
  getSmoothStepPath,
  Position,
} from '@xyflow/react';

import { flowUtilConsts } from '../utils/consts';
import { ApLoopReturnEdge } from '../utils/types';

import { ApAddButton } from './add-button';

export const ApLoopReturnLineCanvasEdge = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  data,
  id,
}: EdgeProps & ApLoopReturnEdge) => {
  const sourcePosition = Position.Right;
  const targetPosition = Position.Top;
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX: data.isLoopEmpty
      ? sourceX + flowUtilConsts.AP_NODE_SIZE.BIG_ADD_BUTTON.width / 2
      : sourceX,
    sourceY: data.isLoopEmpty
      ? sourceY - flowUtilConsts.AP_NODE_SIZE.BIG_ADD_BUTTON.height / 1.7
      : sourceY,
    sourcePosition,
    targetX,
    targetY: targetY + 20,
    targetPosition,
    borderRadius: 20,
  });

  const buttonPosition = {
    x: labelX - flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.width / 2,
    y: labelY - flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.height / 2,
  };

  return (
    <g>
      <BaseEdge
        path={edgePath}
        style={{
          strokeWidth: `${flowUtilConsts.LINE_WIDTH}px`,
          stroke: data.hover ? '#ff0000' : '#999999',
          transition: 'stroke 0.2s ease',
        }}
        className="animated-edge"
      ></BaseEdge>

      {!data.isLoopEmpty && data.hover && (
        <foreignObject
          x={buttonPosition.x}
          y={buttonPosition.y}
          width={flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.width}
          height={flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.height}
          className="overflow-visible"
        >
          <ApAddButton
            edgeId={id}
            stepLocationRelativeToParent={StepLocationRelativeToParent.AFTER}
            parentStepName={data.parentStepName}
          ></ApAddButton>
        </foreignObject>
      )}
    </g>
  );
};
